import * as service from './readings_maintenance.service.js'
import * as poolspecificrangevalues from './readings_pool_specific_range_values.js'

export default {
  //FG - FOOF - I cannot figure out how to remove the "editable" or change the tab
  //  to remove the "X" (make it NOT closable) so in desperation I am using the
  //  vue updated method to remove the "X" when there is only one pool.
  updated() {
      var context=this;
      if(context.numberOfPools == 1 && !context.tab_1_displayHasBeenDone) {
        if(context.tab_1_DOM == null) {
          context.tab_1_DOM = $("#tab-1 .el-icon-close");
          if(context.tab_1_DOM != null) {
            this.$nextTick(() => $("#tab-1 .el-icon-close").css("display","none"))
            context.tab_1_displayHasBeenDone=true;
          }
        }
      }
  },
  
  data() {
  return {
      //inMiddleOfThings: false, //LOOK HERE - zzzzzz

    //vars below make vue's updated method more efficient
      numberOfPools: 0,
      tab_1_displayHasBeenDone: false,
      tab_1_DOM: null,

    //templateModel is used when getting data from and sending data to the server
      templateModel: {
        'LocationId':          '',
        'Name':                '',
        'TemplateReadings':    [],
        'TemplateMaintenance': []
      },

      //FG - FOOF - After Cert - First Release Security
      isAddingOrEditing: 'A', //Default to A

    //Readings
      readings: [],               //ALL of the readings that can possibly be chosen
      displayedReadings: [],      //Either all of the readings or only those chosen
      chosenReadingIds: [],       //List of the id values of the readings that have been chosen
      rangevalues: [],
      showOnlyChosenReadings: false, //v-model for checkbox
    //Pools
      pools: [],                  //All of the pools at a location
      poolListForSelection: [],   //List of pools available when adding a tab
      pool: '',                   //The pool for the chosen tab
    //Tasks
      tasks: [],                  //ALL of the tasks that can possibly be chosen
      displayedTasks: [],         //Either all of the tasks or only those chosen
      chosenTaskIds: [],
      showOnlyChosenTasks: false,        //v-model for checkbox
    //Maintenance
      maintenance: [],                  //ALL of the maintenance items that can possibly be chosen
      displayedMaintenance: [],         //Either all of the maintenance items or only those chosen
      chosenMaintenanceIds: [],
      showOnlyChosenMaintenance: false,        //v-model for checkbox  
    //Tabs (the clickable tabs)
      chosenTabNumber: 0,         //Tabs actually start with 1 so 0 is simply an intialization value
      tabModels: []               //An array of objects that hold the data for the tabs
    }
  },
  props: ['templateData'],
  mounted() {
    let context = this
    this.GetAllLogReadings()
    this.GetAllLogMaintenance()
    this.GetAllLogTasks()
    //this.getpools(this.templateData.LocationId);
    if (!context.templateData.isEdit) {
      context.tabModels = []
    }
    //FG - FOOF - Jan 28 2019 the method below was empty when I got this code from Digiclarity
    //   I modified it when I changed the L&F of the pages that created/maintained
    //   the templates.
    //   Before adding we must initialize variables
    this.$router.app.$on('is_add', function () {
      context.AddingATemplate();
    })
  },
  methods: {
    //FG - FOOF - added the method below so when there is only one pool at a facility
    //   the tab is already set up for that pool.
    //   NOTE: this also initializes the name of the template
    AddingATemplate() {
      var context = this;
      context.templateModel.Name = ''
      context.tabModels = []
      if(context.pools.length == 1) {
        context.pool = context.pools[0];
        context.ok(null,'add');
      }
      else {
        context.handleTabsEdit(null, 'add')
      }
    },

    setDisplayForAddATab() {
      var context=this;
      if(context.pools.length == context.tabModels.length 
        || (!this.$hydrowareSecurityJS.canAdd_A('managetemplates') && context.isAddingOrEditing == 'A')
        || (!this.$hydrowareSecurityJS.canEdit_A('managetemplates') && context.isAddingOrEditing == 'E')
      ) //true when all pools have been chosen already
        $("#readings_maintenance_tabs .el-tabs__new-tab").css( "display", "none" );
      else       
        $( "#readings_maintenance_tabs .el-tabs__new-tab").css( "display", "inline" );
    },

    //Get the log template for which readings etc. will (or have been) chosen
    GetLogTemplateById(id) {
      let context = this
      loader.startLoader()
      service.GetLogTemplateById(id).then(function (response) {
        loader.stopLoader()
        if (response) {
          context.tabModels = []
          context.templateModel.Name = response.Name

          //CREATE THE TABS WITH INITIALIZED VALUES
          //
          //For each pool in the template create a tab model
          //NOTE: the tab model includes the tab's
          //  title, poolId, name (a numeric value), content, 
          //  and INITIALIZED ARRAYS FOR chosen and intial reading ids, maintenance ids, 
          //  and task ids
          response.Pools.map(function (aPoolInTemplate, tabModelIndex) {
              context.tabModels.push({
                title: aPoolInTemplate.PoolName,
                poolId: aPoolInTemplate.PoolId,
                name: tabModelIndex + 1 + '',
                content: 'New Tab content',
                //Choices from the lists
                  chosenReadingIds: [], //These are just reading id values (from logReadings table)
                  chosenMaintenanceIds: [], //These are just maintenance id values (from logMaintenance table)
                  chosenTaskIds: [],    //These are just task id values (from logMaintenance table)
                //Each entry in the initialReadingsIds array holds the id of the row in the 
                //LogTemplateReadings table and the id of a log reading id from the logReadings table
                //NOTE: the logTemplateReadings table connects the reading for a pool with its
                //      template
                  initialReadingIds: [],
                //Each entry in the initialMaintenanceIds array holds the id of the row in the 
                //LogTemplateMaintenance table and the id of a log task id
                //NOTE: the logTemplateMaintenance table connects the maintenance item for a pool with its
                //      template... the column isTask is false on these rows.
                //      the column isTask is what separates the maintenance items from the tasks.
                //ALSO NOTE: BOTH maintenance AND task info is stored in the logMaintenance table
                //           they are also both in the logTemplateMainenance table
                //
                  initialMaintenanceIds: [],
                //Each entry in the initialTaskIds array holds the id of the row in the 
                //LogTemplateMaintenance table and the id of a log task id
                //NOTE: the logTemplateMaintenance table connects the task for a pool with its
                //      template... the column isTask (true for these) is what separates them from maintenance items.
                //ALSO NOTE: BOTH maintenance AND task info is stored in the logMaintenance table
                //           they are also both in the logTemplateMainenance table
                //
                  initialTaskIds: []
              })
          })

          //MAKE THE FIRST TAB THE SELECTED TAB
          //The line below sets the value of the el-tabs v-model and thus 
          //selects the first tab
          context.chosenTabNumber=""+(context.tabModels.length>0 ? context.tabModels[0].name : 0);

          //SET THE VALUES ON EACH TAB
          //For each pool in the template set the tab model's values
          //NOTE: to start out the initial readings and the chosen readings are the same
          response.Pools.map(function (aPoolInTemplate, tabModelIndex) {
            aPoolInTemplate.LogReadings.map(function (anInitialLogReadingInTemplate, notUsedIndex) {
              context.tabModels[tabModelIndex].chosenReadingIds.push(anInitialLogReadingInTemplate.LogReadingsId);
              context.tabModels[tabModelIndex].initialReadingIds.push({
                Id: anInitialLogReadingInTemplate.Id,
                rid: anInitialLogReadingInTemplate.LogReadingsId
              })
            })
            //NOTE: to start out the initial maintenance items and the chosen maintenance items are the same
            //ALSO NOTE: both tasks and maintenance items are stored in the same table
            //  and both use the same "object" thus the use of 
            //  "mid", "LogMaintenances" and "LogMaintenanceId" in the code below is used for both 
            //  maintenance items and tasks
            aPoolInTemplate.LogMaintenances.map(function (anInitialMaintenanceInTemplate, notUsedIndex) {
              context.tabModels[tabModelIndex].chosenMaintenanceIds.push(anInitialMaintenanceInTemplate.LogMaintenanceId) 
              context.tabModels[tabModelIndex].initialMaintenanceIds.push({
                Id: anInitialMaintenanceInTemplate.Id,
                mid: anInitialMaintenanceInTemplate.LogMaintenanceId
              })
            })
            //NOTE: to start out the initial tasks and the chosen tasks are the same
            //ALSO NOTE: both tasks and maintenance items are stored in the same table
            //  and both use the same "object" thus the use of 
            //  "mid", "LogMaintenances" and "LogMaintenanceId" in the code below is used for both
            //  maintenance items and tasks
            aPoolInTemplate.LogTasks.map(function (anInitialTaskInTemplate, notUsedIndex) {
              context.tabModels[tabModelIndex].chosenTaskIds.push(anInitialTaskInTemplate.LogTaskId) 
              context.tabModels[tabModelIndex].initialTaskIds.push({
                Id: anInitialTaskInTemplate.Id,
                mid: anInitialTaskInTemplate.LogMaintenanceId
              })
            })
          })

          context.chosenReadingIds = context.tabModels[0].chosenReadingIds
          context.chosenMaintenanceIds = context.tabModels[0].chosenMaintenanceIds
          context.chosenTaskIds = context.tabModels[0].chosenTaskIds
          context.syncPoolWithTab(context.tabModels[0].poolId)
          context.setDisplayForAddATab()
          context.SetDisplayedReadingsToAllReadings()
          context.SetDisplayedMaintenanceToAllMaintenance()
          context.SetDisplayedTasksToAllTasks()
        } else {
          //context.tabModels = []
        }
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    //The four methods below deal with the Readings display
    GetAllLogReadings() {
      let context = this
      loader.startLoader()
      service.GetAllLogReadings().then(function (response) {
        loader.stopLoader()
        if (response) {
          context.readings = response
        } else {
          context.readings = []
        }
        context.SetDisplayedReadingsToAllReadings();
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    ToggleDisplayedReadings(val) {
      if(val)
      this.SetDisplayedReadingsToChosenReadings()
      else
      this.SetDisplayedReadingsToAllReadings();
    },
    SetDisplayedReadingsToAllReadings() {
      var context=this
      context.displayedReadings=[];
      for(var i=0;i<context.readings.length;i++) {
        context.displayedReadings.push(context.readings[i])
       }
       context.showOnlyChosenReadings=false
    },
    SetDisplayedReadingsToChosenReadings() {
      var context=this
      context.displayedReadings=[];
      for(var i=0;i<context.chosenReadingIds.length;i++) {
        for(var j=0;j<context.readings.length;j++){
          //alert("chosen: " + context.chosenReadingIds[i] + " ? " + context.readings[j].Id)
          if(context.chosenReadingIds[i] == context.readings[j].Id) {
            context.displayedReadings.push(context.readings[j])
            break
          }
        }
      }
      context.showOnlyChosenReadings=true
    },

    //The four methods below deal with the maintenance items display
    GetAllLogMaintenance() {
      let context = this
      loader.startLoader()
      service.GetAllLogMaintenance().then(function (response) {
        loader.stopLoader()
        if (response) {
          context.maintenance = response
        } else {
          context.maintenance = []
        }
        context.SetDisplayedMaintenanceToAllMaintenance();
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    ToggleDisplayedMaintenance(val) {
      if(val)
        this.SetDisplayedMaintenanceToChosenMaintenance()
      else
        this.SetDisplayedMaintenanceToAllMaintenance();
      },
    SetDisplayedMaintenanceToAllMaintenance() {
      var context=this
      context.displayedMaintenance=[];
      for(var i=0;i<context.maintenance.length;i++) {
        context.displayedMaintenance.push(context.maintenance[i])
      }
      context.showOnlyChosenMaintenance=false
    },
    SetDisplayedMaintenanceToChosenMaintenance() {
      var context=this
      context.displayedMaintenance=[];
      for(var i=0;i<context.chosenMaintenanceIds.length;i++) {
        for(var j=0;j<context.maintenance.length;j++){
          if(context.chosenMaintenanceIds[i] == context.maintenance[j].Id) {
            context.displayedMaintenance.push(context.maintenance[j])
            break
          }
        }
      }
      context.showOnlyChosenMaintenance=true
    },
    //The four methods below deal with the tasks that display
    GetAllLogTasks() {
      let context = this
      loader.startLoader()
      service.GetAllLogTasks().then(function (response) {
        loader.stopLoader()
        if (response) {
          context.tasks = response
        } else {
          context.tasks = []
        }
        context.SetDisplayedTasksToAllTasks();
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    ToggleDisplayedTasks(val) {
      if(val)
      this.SetDisplayedTasksToChosenTasks()
      else
      this.SetDisplayedTasksToAllTasks();
    },
    SetDisplayedTasksToAllTasks() {
      var context=this
      context.displayedTasks=[];
      for(var i=0;i<context.tasks.length;i++) {
        context.displayedTasks.push(context.tasks[i])
       }
       context.showOnlyChosenTasks=false
    },
    SetDisplayedTasksToChosenTasks() {
      var context=this
      context.displayedTasks=[];
      for(var i=0;i<context.chosenTaskIds.length;i++) {
        for(var j=0;j<context.tasks.length;j++){
          if(context.chosenTaskIds[i] == context.tasks[j].Id) {
            context.displayedTasks.push(context.tasks[j])
            break
          }
        }
      }
      context.showOnlyChosenTasks=true
    },


    //FG - FOOF - Jan 28 2019 - added method below
    showListOfTemplates() {
      this.templateData.templateId = null; //reset this so edit click on list page works properly
      this.templateData.chemsettingscontroller.showTemplatevit()
    },
    readingAppend(index) {
      this.tabModels[index].chosenReadingIds = this.chosenReadingIds //zzzzzz
    },
    maintenanceAppend(index) {
      this.tabModels[index].chosenMaintenanceIds = this.chosenMaintenanceIds //yyyyyy
    },
    taskAppend(index) {
      this.tabModels[index].chosenTaskIds = this.chosenTaskIds //yyyyyy
    },
    tabClick(tab, event) {
      /*****************STOPPED TRYING TO GET THIS TO WORK.. USING DEFAULT "+"
      if(tab.label=="+") {
        this.handleTabsEdit('','add');
        event.stopPropagation();
        return;
      }
      ********************************************************************/
      this.syncPoolWithTab(this.tabModels[tab.index].poolId)
      this.chosenReadingIds = this.tabModels[tab.index].chosenReadingIds 
      this.chosenTaskIds = this.tabModels[tab.index].chosenTaskIds
      this.chosenMaintenanceIds = this.tabModels[tab.index].chosenMaintenanceIds;
      this.SetDisplayedReadingsToAllReadings();
      this.SetDisplayedMaintenanceToAllMaintenance();
      this.SetDisplayedTasksToAllTasks();
    },

    /***********************************************
     * This syncs up the pool in the drop downs with
     * the selected tab.
    ************************************************/
    syncPoolWithTab(aPoolId) {
      var context = this;
        var context = this;
        if(aPoolId == null || aPoolId.length==0) {
          context.pool = ''
        }
        else {
          context.pool = this.getPoolForId(aPoolId)
        }
    },
    //FG - FOOF - Jan 2 2019 added method below
    /*************************************************
    * This method finds the pool that corresponds to
    * the pool id and it was created in order to find 
    * the values that are specific to a pool.
    **************************************************/
    getPoolForId(aPoolId) {
      var context = this;
      var poolToReturn=null;
      for(var i=0;i<context.pools.length;i++) {
        if(aPoolId == context.pools[i].PoolId)
          return context.pools[i];
      }
      return '';
    },
    ok(targetName, action) {
      let context = this
      let newTabName = this.tabModels.length+1;
      this.tabModels.push({
        title: context.pool.PoolName,
        poolId: context.pool.PoolId,
        name: ""+(newTabName),
        content: 'New Tab content',
        chosenReadingIds: [], 
        chosenMaintenanceIds: [],
        chosenTaskIds: [] 
      })
      context.chosenTabNumber=""+(newTabName);
      context.chosenReadingIds=[]
      context.chosenTaskIds=[]
      context.chosenMaintenanceIds=[]
      context.setDisplayForAddATab();
      context.SetDisplayedReadingsToAllReadings();
      context.SetDisplayedTasksToAllTasks();
      context.SetDisplayedMaintenanceToAllMaintenance();
    },
    //FG - FOOF - Jan 25 2019 - added method below to create a list of pools 
    //  for the select pool modal dialog.  The list will contain pools for
    //  which a tab does not exist
    createPoolListForSelection() {
      //alert("CREATE POOL LIST FOR SELECTION\nIN MIDDLE: " + this.inMiddleOfThings)
      var context=this;
      context.poolListForSelection = [];
      for(var pIndex=0;pIndex<context.pools.length;pIndex++) {
        var addPoolToList = true;
        for(var etIndex=0;etIndex<context.tabModels.length;etIndex++) {
          if(context.pools[pIndex].PoolId == context.tabModels[etIndex].poolId) {
            addPoolToList = false;
            etIndex = context.tabModels.length; //need look no more
          }
        }
        if(addPoolToList) {
          context.poolListForSelection.push(context.pools[pIndex])
        }
      }
      //alert("CONTEXT POOLs: " + context.poolListForSelection.length)
    },
    removeTab(target){
      this.handleTabsEdit(target,'remove');
    },
    handleTabsEdit(targetName, action) {
      let context = this
      context.pool = ''
      if (action === 'add') {
        this.createPoolListForSelection();
        //alert(context.poolListForSelection.length)
        $('#PoolSelectModel').modal('show')
        $('#addTabs').off('click').on('click', function (e) {
          context.ok(targetName, action)
          $('#PoolSelectModel').modal('hide')
          context.setDisplayForAddATab();
          //context.inMiddleOfThings=true //LOOK HERE - zzzzzz
        })
      }
      if (action === 'remove') {
        let tabs = context.tabModels
        let activeName = context.chosenTabNumber
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        context.chosenTabNumber = activeName
        context.tabModels = tabs.filter(tab => tab.name !== targetName)
        context.setDisplayForAddATab();
        context.SetDisplayedReadingsToAllReadings();
        context.SetDisplayedTasksToAllTasks();
        context.SetDisplayedMaintenanceToAllMaintenance();
        if(context.tabModels.length == 0) {
          context.handleTabsEdit(null,'add')
        }
      }
    },
    handleClick(ev) {
      $('#PoolSelectModel').modal('show')
    },
    updateTemplate() { //used to be updateReading
      let context = this
      loader.startLoader()
      context.templateModel['TemplateReadings'] = []
      context.templateModel['TemplateMaintenance'] = []  //NOTE: BOTH TASKS AND MAINT. ITEMS END UP IN THIS SLOT
      //READINGS
      this.tabModels.map(function (aTabModel, tabModelIndex) {
        aTabModel.chosenReadingIds.map(function (aChosenReadingId, chosenReadingIdIndex) {
          var rei
          if (aTabModel.initialReadingIds                          //initialReadingsId array is not null
            && aTabModel.initialReadingIds.length > 0              //and it has at least one entry
            && aTabModel.initialReadingIds[chosenReadingIdIndex]) {//and there is an entry for the chosenReadingIdIndex
            if (aTabModel.initialReadingIds[chosenReadingIdIndex].rid == aChosenReadingId) {
                rei = aTabModel.initialReadingIds[chosenReadingIdIndex].Id
            } 
            else {
              rei = 0
            }
          } 
          else {
            rei = 0
          }
          context.templateModel['TemplateReadings'].push({
            Id: rei,
            LogReadingsId: aChosenReadingId,
            Ordinance: chosenReadingIdIndex,
            PoolId: aTabModel.poolId
          })
        })
        //NOTE: both the maintenance items and the tasks end up in the same table
        //and thus are both sent to the server in the 'TemplateMaintenance' slot.
        //MAINTENANCE
        aTabModel.chosenMaintenanceIds.map(function (aChosenMaintenanceId, chosenMaintenanceIdIndex) {
          var mei
          if (aTabModel.initialMaintenanceIds
            && aTabModel.initialMaintenanceIds.length > 0 
            && aTabModel.initialMaintenanceIds[chosenMaintenanceIdIndex]) {
              if (aTabModel.initialMaintenanceIds[chosenMaintenanceIdIndex].mid == aChosenMaintenanceId) {
                mei = aTabModel.initialMaintenanceIds[chosenMaintenanceIdIndex].Id
              } else {
                mei = 0
              }
          } else {
            mei = 0
          }
          context.templateModel['TemplateMaintenance'].push({
            Id: mei,
            LogMaintenanceId: aChosenMaintenanceId,
            Ordinance: chosenMaintenanceIdIndex,
            PoolId: aTabModel.poolId
          })
        })
        //TASKS
        aTabModel.chosenTaskIds.map(function (aChosenTaskId, chosenTaskIdIndex) {
          var mei
          if (aTabModel.initialTaskIds) {
            if (aTabModel.initialTaskIds.length > 0 && aTabModel.initialTaskIds[chosenTaskIdIndex]) {
              if (aTabModel.initialTaskIds[chosenTaskIdIndex].mid == aChosenTaskId) {
                mei = aTabModel.initialTaskIds[chosenTaskIdIndex].Id
              } else {
                mei = 0
              }
            } else {
              mei = 0
            }
          } else {
            mei = 0
          }
          context.templateModel['TemplateMaintenance'].push({
            Id: mei,
            LogMaintenanceId: aChosenTaskId,
            Ordinance: chosenTaskIdIndex,
            PoolId: aTabModel.poolId
          })
        })
      })
      context.templateModel.Id = context.templateData.templateId
      service.UpdateLogTemplate(this.templateModel).then(function (response) {
        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Template Updated',
          type: 'success'
        })
        context.$router.app.$emit('hydroware_readingsTemplateSaved')
        loader.stopLoader()
      }, (error) => {
        context.onRequest = false
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
        loader.stopLoader()
      })
    },
   addTemplate() {
    let context = this
    loader.startLoader()
    this.tabModels.map(function (aTabModel, tabModelIndex) {
      aTabModel.chosenReadingIds.map(function (aChosenReadingId, chosenReadingsIdIndex) {
        context.templateModel['TemplateReadings'].push({
          Id: 0,
          LogReadingsId: aChosenReadingId,
          Ordinance: chosenReadingsIdIndex,
          PoolId: aTabModel.poolId
        })
      })
      aTabModel.chosenMaintenanceIds.map(function (aChosenMaintenanceId, chosenMaintenanceIdIndex) {
        context.templateModel['TemplateMaintenance'].push({
          Id: 0,
          LogMaintenanceId: aChosenMaintenanceId,
          Ordinance: chosenMaintenanceIdIndex,
          PoolId: aTabModel.poolId
        })
      })
      aTabModel.chosenTaskIds.map(function (aChosenTaskId, chosenTaskIdIndex) {
        //context.templateModel['TemplateTasks'].push({
        context.templateModel['TemplateMaintenance'].push({
          Id: 0,
          LogMaintenanceId: aChosenTaskId,
          Ordinance: chosenTaskIdIndex,
          PoolId: aTabModel.poolId
        })
      })
    })
    service.AddLogTemplate(this.templateModel).then(function (response) {
      loader.stopLoader()
      context.$notify({
        title: 'Success',
        message: 'New Template Created',
        type: 'success'
      })
      context.$router.app.$emit('hydroware_readingsTemplateSaved')
      loader.stopLoader()
    }, (error) => {
      context.onRequest = false
      context.$notify({
        title: 'Error',
        message: error.responseJSON.Message,
        type: 'error'
      })
      loader.stopLoader()
    })
  },
    getpools(locationid) {
      let context = this

      //initialize the vars that help with the updated method
      context.tab_1_displayHasBeenDone=false;
      context.tab_1_DOM = null;
      //$( "#readings_maintenance_tabs .el-tabs__new-tab").css( "display", "inline" );

      service.GetPools(locationid).then(function (response) {
        if (response) {
          if (response.length > 0) {
            context.pools = response 
          }
          else {
            context.pools = [];
          }
          context.numberOfPools = response.length; 
        }
      }, (error) => {}
      )
    },
    //The function below gets the range values for the readings, processes them and makes them display
    showrange() {
      let context = this
      context.rangevalues = []
      //Get the range values for a specific location and use the "then" function
      //to process them. 
      service.GetRangeValue(authDetails.OrganizationId).then(function (response) {
        //
        for(var i=0;i<response.length;i++) {
          //FG - Jan 11 2019 is there is no PoolSpecificHint then put this row in the arrayToDisplay
          //     NOTE: values with a pool specific hint need further processing to get the pools
          //     specific range values.
          if(!response[i].PoolSpecificHint) {
              context.rangevalues.push(response[i]);
          }
          else {
            //FG - FOOF - Jan 5 2018 - call upon the setupPoolSpecifiValues
            //function in order to fill in the pool specific values to the
            //table 
            poolspecificrangevalues.setupPoolSpecificRangeValues(
                context.rangevalues,
                response[i],
                context.pool,
                context.pools
             );
          }
        }
        //Show the range values pop up
        $('#ViewRangeValuemodel').modal('show'); 
      }, 
      (error) => {
      })
    },
  },
  watch: {
    'templateData.LocationId': function () {
      this.templateModel.LocationId = this.templateData.LocationId
      this.getpools(this.templateData.LocationId)
    },
    'templateData.isEdit': function () {
      if (this.templateData.isEdit) {
        this.isediting = true
        this.isAddingOrEditing = 'E' //FG - After Cert - First Release Security
      } else {
        this.isediting = false
        this.isAddingOrEditing = 'A' //FG - After Cert - First Release Security
      }
    },
    'templateData.templateId': function () {
      if(this.templateData.templateId == null) return; //FG - FOOF - Jan 25 2019
      this.isediting = true
      
      if (this.templateData.isEdit) {
        this.isAddingOrEditing = 'E' //FG - After Cert - First Release Security
        this.GetLogTemplateById(this.templateData.templateId)
      }
    },
  }

}


// WEBPACK FOOTER //
// ./src/components/ReadingsMaintenance/readings_maintenance.controller.js